import Page from "../../page";
import ClientUpload from "../../../components/upload/client-upload";

const ClientUploadPage = () => {
  return (
    <Page>
      <ClientUpload />
    </Page>
  );
};

export default ClientUploadPage;
